module.exports = __webpack_public_path__ + "fonts/effect-mostly-average-joes-db5ece.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-mostly-average-joes.svg
// module id = 794
// module chunks = 0